var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomR(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5.643H.5m0 11h11",
    stroke: "#131A4F",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5.643v11",
    stroke: "#131A4F",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeDasharray: "1 2"
  })));
}
export default __webpack_public_path__ + "a89553af4189474930b5377b409e9874.svg";
export { SvgCustomR as ReactComponent };